import { Link } from "react-router-dom";
import { Car, Phone, Mail, MapPin, Clock, Facebook } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-2 group">
              <div className="relative">
                <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center">
                  <Car className="w-7 h-7 text-white" />
                </div>
                <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 rounded-full" />
              </div>
              <div className="flex flex-col">
                <span className="font-extrabold text-2xl tracking-tight font-['Archivo']">
                  AUTO CORA
                </span>
                <span className="text-xs text-slate-400 tracking-widest uppercase">
                  Școala de Șoferi
                </span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Pregătim viitori șoferi profesioniști cu răbdare și dedicare. 
              Alege calitatea și siguranța pentru drumul tău spre permis.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/AutoCora"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                className="w-10 h-10 bg-slate-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Archivo']">Link-uri Rapide</h4>
            <ul className="space-y-3">
              {[
                { name: "Acasă", path: "/" },
                { name: "Servicii", path: "/servicii" },
                { name: "Despre Noi", path: "/despre" },
                { name: "Programări", path: "/programari" },
                { name: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-white transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Archivo']">Categorii Permis</h4>
            <ul className="space-y-3">
              {["B - Cutie Manuală", "B - Cutie Automată", "B Extins - Fără Examene", "B+E - Cu remorcă", "C - Camion", "C+E - TIR"].map(
                (cat) => (
                  <li key={cat}>
                    <span className="text-slate-400 text-sm">{cat}</span>
                  </li>
                )
              )}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Archivo']">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Telefon</p>
                  <a href="tel:+40740245376" className="text-slate-400 text-sm hover:text-white transition-colors">
                    0740 245 376
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Email</p>
                  <a href="mailto:auto.cora12@gmail.com" className="text-slate-400 text-sm hover:text-white transition-colors">
                   auto.cora12@gmail.com
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Adresă</p>
                  <p className="text-slate-400 text-sm"> 
                    Str. Nicolae Bălcescu Nr. 1, Falticeni, Romania<br />
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-white font-medium">Program</p>
                  <p className="text-slate-400 text-sm">
                    Luni - Vineri: 08:00 - 17:00
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-slate-400 text-sm text-center md:text-left">
              © {currentYear} AUTO CORA - Școala de Șoferi. Toate drepturile rezervate.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
              <Link to="/politica-confidentialitate" className="text-slate-400 hover:text-white transition-colors">
                Confidențialitate
              </Link>
              <span className="text-slate-700">|</span>
              <Link to="/termeni-conditii" className="text-slate-400 hover:text-white transition-colors">
                Termeni și Condiții
              </Link>
              <span className="text-slate-700">|</span>
              <Link to="/politica-cookies" className="text-slate-400 hover:text-white transition-colors">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
